import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Divider, Form, Input, Row, Space } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useEffect, useRef } from "react";
import { FormaPagamentoRecebimentoModel } from "../../../../models/formaPagamentoRecebimento/formaPagamentoRecebimentoModel";
import { atualizarFormaPagamentoRecebimento, cadastrarFormaPagamentoRecebimento, buscarFormaPagamentoRecebimento } from "../../../../services/formaPagamentoRecebimentoService";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { setModalCadastrarFormaPagamentoRecebimento } from "../../../../redux/slices/formaPagamentoRecebimento/formaPagamentoRecebimentoSlice";
import { toastError } from "../../../../util/toast";

const CadastroFormaPagamentoRecebimento = () => {
  //estados globais
  const formaPagamentoRecebimentoState = useAppSelector((state) => state.formaPagamentoRecebimento);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<FormaPagamentoRecebimentoModel>();

  const editar = Object.values(formaPagamentoRecebimentoState.entity).length !== 0;

  const inputInicial = useRef<any>();

  useEffect(() => {
    if (inputInicial.current && !editar) {
      inputInicial.current.focus();
    }
    if (editar) {
      form.setFieldsValue({ ...formaPagamentoRecebimentoState.entity });
    } else {
      form.setFieldsValue({ ativo: true });
    }
  }, [formaPagamentoRecebimentoState.entity]);

  const submit = (values: FormaPagamentoRecebimentoModel) => {
    const searchName = formaPagamentoRecebimentoState.list.filter(({ denominacao }: any) => denominacao === values.denominacao);
    if (searchName.length !== 0 && formaPagamentoRecebimentoState.entity.denominacao !== values.denominacao) {
      toastError("Já existe uma forma de pagamento com esse nome!");
    } else {
      if (editar) {
        dispatch(atualizarFormaPagamentoRecebimento({ value: { ...values, id: formaPagamentoRecebimentoState.entity.id }, busca: formaPagamentoRecebimentoState.busca }));
      } else {
        dispatch(cadastrarFormaPagamentoRecebimento({ value: values, busca: formaPagamentoRecebimentoState.busca }));
      }
    }
  };

  const voltar = () => {
    dispatch(setModalCadastrarFormaPagamentoRecebimento(false));
  };

  const validarCheckReceitaDespesa = () => {
    if (!form.getFieldValue("receita") && !form.getFieldValue("despesa")) {
      return Promise.reject("Selecione");
    }
    return Promise.resolve();
  };

  return (
    <Form form={form} onFinish={submit} layout="vertical">
      <Row gutter={12} justify="space-between">
        <Col>
          <Form.Item
            label="Denominação"
            name="denominacao"
            rules={[
              {
                required: true,
                message: "Digite a denominação",
              },
            ]}
          >
            <Input type="text" style={{ width: "444px" }} placeholder="Digite a denominação" ref={inputInicial} />
          </Form.Item>
        </Col>
        <Col>
          <span>Categoria</span>
          <div className="tipoCusto">
            <Form.Item name="receita" label="" valuePropName="checked" rules={[{ validator: validarCheckReceitaDespesa }]} dependencies={["despesa"]}>
              <Checkbox style={{ fontSize: "14px" }}>Receita</Checkbox>
            </Form.Item>

            <Form.Item name="despesa" label="" valuePropName="checked" rules={[{ validator: validarCheckReceitaDespesa }]} dependencies={["receita"]}>
              <Checkbox name="despesa" style={{ fontSize: "14px" }}>
                Despesa
              </Checkbox>
            </Form.Item>
          </div>
        </Col>
        <Col>
          <Form.Item name="ativo" label="Ativo" valuePropName="checked">
            <Checkbox name="ativo" style={{ fontSize: "14px", paddingTop: "5px" }}>
              Ativo
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col style={{ width: "100%" }}>
          <Form.Item
            label="Descrição"
            name="descricao"
            rules={[
              {
                required: true,
                message: "Digite a descrição",
              },
            ]}
          >
            <TextArea rows={3} style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <div className="modalFooter">
        <Space size="middle">
          <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
            FECHAR
          </Button>
          <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
            {editar ? "ATUALIZAR" : "SALVAR"}
          </Button>
        </Space>
      </div>
    </Form>
  );
};

export default CadastroFormaPagamentoRecebimento;
